export default function (id, bem) {
  let window = typeof id !== 'undefined' ? `bem.proprietario.${id}.show` : 'bem.proprietario.new'
  !this.$uloc.window.get(window) && this.$uloc.window.new({
    wid: window,
    title: 'Novo Proprietário',
    move: false,
    backdrop: true,
    clickOutside: false,
    closeOnEsc: false,
    windowClass: 'erp-window-modern v2 no-border-radius',
    width: '700',
    height: '680',
    props: {
      id: id,
      $router: this.$router,
      bem: bem
    }
  }, () => import('./Proprietario'))
    .then((wid) => {
      this.$uloc.window.listen(wid, {
        updated: (wid, val) => {
          console.log('Update event')
          this.load && this.load()
          this.entityUpdate && this.entityUpdate(val)
        },
        created: (wid, val) => {
          console.log('Create event')
          this.load && this.load()
          this.entityUpdate && this.entityUpdate(val)
        }
      })
    }) // return wid
}
